const noteTypeEnum = Object.freeze({
	intakeNote: 'IntakeNote',
	billingNote: 'BillingNote',
	payorNote: 'PayorNote',
	documentNote: 'DocumentNote',
	note: 'Note',
});

export default noteTypeEnum;
